import { Component, Output, EventEmitter, ElementRef, ViewChild, AfterViewInit, OnChanges, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Materials } from './materialOptions.interface';
import { Utils } from '../../../service/utils';
import { ConversionFormulas } from '../../../service/formulas/conversionsFormulas';
import { CacheService } from 'ionic-cache';
import { CommonService } from '../../../service/common.service';
import { Formulas } from '../../../service/formulas/formulas';
import { Message } from '../../../service/dialog/message.interface';
import { ToolContainer, Material_, Cutter_ } from '../../../service/formulas/objects';
import { Constants } from '../../../service/constants';
import { HardnessFactor, Hardness } from '../hardness.model';
import _ from 'lodash';
import * as $ from 'jquery';
import Fuse from 'fuse.js';

@Component({
  selector: 'section-material',
  templateUrl: 'material.html',
  providers: [ConversionFormulas],
  styleUrls: ['material.scss']
})
export class Material implements AfterViewInit, OnChanges {
  private subscription: Subscription;
  public windowsDimensions: object = undefined;
  private settingsHolder: ToolContainer;
  material: FormGroup;
  isSubmitted: boolean;
  resetHardnessActive: boolean;
  errorMessage: string;
  filteredMaterials: any;
  filteredSubgroups: string[];
  filteredConditions: any;
  private currentSubgroup: string = '';
  materialView: boolean;
  popupVisible: object;
  chosenCondition: boolean = false;
  showConditionHint: boolean = false;
  currentHardness: object;
  materialData: object;
  isApp: boolean;
  private currentTool: Cutter_;
  public subGroup: Array<string>;
  private materialList: Array<string>;
  private materialSubgroupList: Array<string>;
  private conditionList: Array<string>;
  private previousMaterialList: Array<string>;
  private fuseSearch: any;
  private fuseSearchOptions = {
    shouldSort: false,
    threshold: 0.2,
    ignoreLocation: true,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    tokenize: true,
    keys: ['uiName']
  };
  @Output() hardnessChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() materialChange: EventEmitter<any> = new EventEmitter<any>();
  @Input('ndcDynamicInputs') materials: Materials;

  @ViewChild('materialInput', { static: false }) materialInput: ElementRef;
  @ViewChild('materialOptions', { static: false }) materialOptions: ElementRef;
  @ViewChild('materialOptionsPop', { static: false }) materialOptionsPop: ElementRef;
  @ViewChild('subgroupInput', { static: false }) subgroupInput: ElementRef;
  @ViewChild('subgroupOptions', { static: false }) subgroupOptions: ElementRef;
  @ViewChild('subgroupOptionsPop', { static: false }) subgroupOptionsPop: ElementRef;
  @ViewChild('conditionInput', { static: false }) conditionInput: ElementRef;
  @ViewChild('conditionOptions', { static: false }) conditionOptions: ElementRef;
  @ViewChild('conditionOptionsPop', { static: false }) conditionOptionsPop: ElementRef;

  @ViewChild('hbw', { static: false }) hbw: ElementRef;
  @ViewChild('hbs', { static: false }) hbs: ElementRef;
  @ViewChild('hrb', { static: false }) hrb: ElementRef;
  @ViewChild('hrc', { static: false }) hrc: ElementRef;

  constructor(
    public utils: Utils,
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private conversionFormulas: ConversionFormulas,
    private commonService: CommonService,
    private formulas: Formulas,
    private cache: CacheService,
    private constants: Constants
  ) {
    this.currentTool = new Cutter_();
    this.material = this.formBuilder.group({
      materialSelection: this.formBuilder.group({
        material: new FormControl(''),
        subgroup: new FormControl(''),
        condition: new FormControl({ value: '', disabled: true }),
        subgroupSearch: new FormControl(''),
        materialSearch: new FormControl(''),
        conditionSearch: new FormControl('')
      }),
      hardness: this.formBuilder.group({
        hbw: new FormControl('', [Validators.pattern(this.constants.NUMBER_ONLY_REGEX)]),
        hrc: new FormControl('', [Validators.pattern(this.constants.NUMBER_ONLY_REGEX)]),
        hbs: new FormControl('', [Validators.pattern(this.constants.NUMBER_ONLY_REGEX)]),
        hrb: new FormControl('', [Validators.pattern(this.constants.NUMBER_ONLY_REGEX)]),
        userHra: new FormControl('', [Validators.pattern(this.constants.NUMBER_ONLY_REGEX)])
      })
    });

    this.isApp = this.utils.isApp();
    if (this.isApp) {
      this.cache.getItem('windowsDimensions').then(windowsDimensions => {
        this.windowsDimensions = windowsDimensions;
      });
    }
    this.materialView = true;
    this.chosenCondition = false;
    this.errorMessage = '';
    this.isSubmitted = false;
    this.resetHardnessActive = false;

    this.popupVisible = {
      material: false,
      subgroup: false,
      condition: false
    };
  }

  ngOnChanges(changes) {
    this.materials = {
      all: changes.all.currentValue,
      conditions: changes.conditions.currentValue,
      materials: changes.materials.currentValue,
      subgroups: changes.subgroups.currentValue
    };

    // Populate UI bindings of materials once data is available
    if (
      !this.currentTool.id &&
      (!this.subGroup ||
        !this.materialList ||
        (this.subGroup && !this.subGroup.length) ||
        (this.materialList && !this.materialList.length))
    ) {
      this.resetMaterialList(false);
    }
  }

  resetList = () => {
    this.filteredMaterials = _.orderBy(this.materials['materials']);
    this.filteredSubgroups = _.orderBy(this.materials['subgroups']);
    this.filteredConditions = _.orderBy(this.materials['conditions']);
    this.subGroup = this.filteredSubgroups;
    this.materialList = this.filteredMaterials;
  };

  resetMaterialList = (resetMaterial: boolean = true) => {
    this.materialSubgroupList = [];
    this.conditionList = [];
    this.previousMaterialList = undefined;
    this.settingsHolder = new ToolContainer();
    this.currentTool = new Cutter_();
    if (resetMaterial) {
      this.resetMaterial();
    }
    this.materialList = _.orderBy(_.uniqBy(this.materials['all'], 'uiName')); // default, incase user want to just click on subgroup
    this.filteredSubgroups = _.orderBy(this.materials['subgroups']);
    this.subGroup = this.filteredSubgroups;
    this.chosenCondition = false;
    this.material
      .get('materialSelection')
      .get('condition')
      .disable();
  };

  putInView = (evt: any, alignToTop: boolean) => {
    //alighToTop is passed in so the dropdown can be aligned to the top and the dropdown opens below the field
    //All input fields we want to align to bottom, alightTopTop false, because it was causing styling issues when aligning to top
    let input = evt.currentTarget;
    if (this.isApp) {
      setTimeout(() => {
        input.scrollIntoView(alignToTop);
      }, 350);
    }
  };

  ngAfterViewInit() {
    this.resetList();
    this.materialList = _.orderBy(_.uniqBy(this.materials['all'], 'uiName')); // default, incase user want to just click on subgroup
    this.fuseSearch = new Fuse(this.materialList, this.fuseSearchOptions);

    this.materialOptionsPop.nativeElement.className = 'down arrow';
    this.subgroupOptionsPop.nativeElement.className = 'down arrow';
    this.conditionOptionsPop.nativeElement.className = 'down arrow';

    this.material
      .get('materialSelection')
      .get('subgroup')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: string) => {
        //need to update the filtered lists
        if (value !== '') {
          this.subGroup = _.filter(this.filteredSubgroups, material => {
            //autocomplete filtering
            if (material.toLowerCase().includes(value.toLowerCase())) {
              return material;
            }
          });
        } else {
          this.subGroup = this.filteredSubgroups;
          this.materialSubgroupList = _.orderBy(_.uniqBy(this.materials['all'], 'uiName'));
          this.materialList = _.clone(this.materialSubgroupList);
        }
      });

    this.material
      .get('materialSelection')
      .get('material')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: any) => {
        //need to update the filtered lists
        if (value !== '') {
          if (typeof value === 'object') {
            value = value.uiName;
          }
          if (!!!this.materialSubgroupList || this.materialSubgroupList.length <= 0) {
            this.materialSubgroupList = _.orderBy(_.uniqBy(this.materials['all'], 'uiName'));
          }
          this.fuseSearch = new Fuse(this.materialList, this.fuseSearchOptions);
          this.materialList = this.fuseSearch.search(value.toLowerCase());
        } else {
          this.materialList = this.materialSubgroupList;
        }
      });

    this.material
      .get('materialSelection')
      .get('condition')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((value: string) => {
        const isCondition = _.find(this.conditionList, c => {
          return c.condition === value;
        });

        this.showConditionHint = this.conditionList.length > 0 && !isCondition;
      });

    //need to have ALL three OR atleast material and condition be chosen before emit
    this.material.get('hardness').valueChanges.subscribe(() => {
      if (this.material.get('hardness').value !== this.currentHardness) {
        this.resetHardnessActive = true;
      }
    });

    this.subscription = this.commonService.notifyObservable$.subscribe(res => {
      if (res.hasOwnProperty('option') && res.option === 'logout') {
        this.subscription.unsubscribe();
      }
      if (res.hasOwnProperty('option') && res.option === 'setMaterial') {
        this.materials = res.value;
      }
      if (res.hasOwnProperty('option') && res.option === 'material') {
        if (res.value === 'resetMaterial') {
          this.resetMaterial();
        } else {
          this.setsMaterialList(res.value);
        }
      }

      if (res.hasOwnProperty('option') && res.option === 'reset') {
        this.resetMaterialList();
      }

      if (res.hasOwnProperty('option') && res.option === 'resetMaterial') {
        this.resetMaterialList();
        this.setsMaterialList(res.value, true);
      }
    });

    this.material
      .get('hardness')
      .get('hbw')
      .valueChanges.pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe((input: string) => {
        if (input && this.constants.NUMBER_ONLY_REGEX.test(input)) {
          const hbw: number = Number(input);
          if (hbw > 0) {
            if (hbw < 100) {
              let message: Message = {
                title: 'Cannot go below 100 HBW!',
                message: 'A value of ' + hbw + ' is too low for accurate HBW 10/3000 Brinell hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else if (hbw > 654) {
              let message: Message = {
                title: 'Cannot go above 654 HBW!',
                message: 'A value of ' + hbw + ' is too high for accurate HBW 10/3000 Brinell hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else {
              this.hardnessOverride(HardnessFactor.HBW, hbw);
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('HBW (Numeric)');
          }
        }
      });

    this.material
      .get('hardness')
      .get('hbs')
      .valueChanges.pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe((input: string) => {
        if (input && this.constants.NUMBER_ONLY_REGEX.test(input)) {
          const hbs: number = Number(input);
          if (hbs > 0) {
            if (hbs < 40) {
              let message: Message = {
                title: 'Cannot go below 40 HBS!',
                message: 'A value of ' + hbs + ' is too low for accurate HBS 10/500 Brinell hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else if (hbs > 160) {
              let message: Message = {
                title: 'Cannot go above 160 HBS!',
                message:
                  'A value of ' +
                  hbs +
                  ' is too high for accurate HBS 10/500 Brinell hardness testing in this material!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else {
              this.hardnessOverride(HardnessFactor.HBS, hbs);
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('HBS (Numeric)');
          }
        }
      });

    this.material
      .get('hardness')
      .get('hrc')
      .valueChanges.pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe((input: string) => {
        if (input && this.constants.NUMBER_ONLY_REGEX.test(input)) {
          const hrc: number = Number(input);
          if (hrc > 0) {
            if (hrc < 20) {
              let message: Message = {
                title: 'Cannot go below 20 HRC!',
                message: 'A value of ' + hrc + ' is too low for accurate Rockwell C hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else if (hrc > 70) {
              let message: Message = {
                title: 'Cannot go above 70 HRC!',
                message: 'A value of ' + hrc + ' is too high for accurate Rockwell C hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else {
              this.hardnessOverride(HardnessFactor.HRC, hrc);
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('HRC (Numeric)');
          }
        }
      });

    this.material
      .get('hardness')
      .get('hrb')
      .valueChanges.pipe(debounceTime(3000), distinctUntilChanged())
      .subscribe((input: string) => {
        if (input && this.constants.NUMBER_ONLY_REGEX.test(input)) {
          const hrb: number = Number(input);
          if (hrb > 0) {
            if (hrb < 28) {
              let message: Message = {
                title: 'Cannot go below 28 HRB!',
                message: 'A value of ' + hrb + ' is too low for accurate Rockwell B hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else if (hrb > 100) {
              let message: Message = {
                title: 'Cannot go above 100 HRB!',
                message: 'A value of ' + hrb + ' is too high for accurate Rockwell B hardness testing!'
              };
              this.utils.openDialog(message, 'error');
              this.resetHardness();
            } else {
              this.hardnessOverride(HardnessFactor.HRB, hrb);
            }
          }
          if (this.isApp) {
            this.utils.apptentiveEngage('HRB (Numeric)');
          }
        }
      });
  }

  setsMaterialList = (settingsHolder: ToolContainer, resetMaterial: boolean = false) => {
    this.settingsHolder = settingsHolder;
    if (this.settingsHolder.tool !== this.currentTool) {
      if (this.settingsHolder.tool) {
        this.currentTool = this.settingsHolder.tool;
        // we need to filter the materials, this will alleviate some of the shading area errors
        let toolFilteredList = [];
        let toolSubGroup = [];
        let materialList = _.orderBy(this.materials['all'], 'uiName');
        let materialIds = this.settingsHolder.tool.materialIds;
        for (let i = 0; i < materialList.length; i++) {
          let material = <Material_>materialList[i];
          if (materialIds.includes(material.id)) {
            toolFilteredList.push(material);
            //grabbing the subgroups
            if (toolSubGroup.indexOf(material.subGroup) < 0) {
              toolSubGroup.push(material.subGroup);
            }
          }
        }

        let differ = true;
        if (this.previousMaterialList) {
          differ = !_.isEmpty(this.utils.difference(toolFilteredList, this.previousMaterialList));
        }
        if (resetMaterial || differ) {
          let materialInput = this.material.get('materialSelection').get('material').value;
          let subGroupInput = this.material.get('materialSelection').get('subgroup').value;
          let conditionInput = this.material.get('materialSelection').get('condition').value;

          this.settingsHolder.tool = this.currentTool;
          this.previousMaterialList = toolFilteredList;
          this.resetMaterial();
          this.materialList = _.uniqBy(toolFilteredList, 'uiName');
          this.filteredSubgroups = _.orderBy(toolSubGroup);
          this.subGroup = this.filteredSubgroups;
          this.chosenCondition = false;

          // if my previous selection is available in the current list, then preselect for user
          if (subGroupInput !== '') {
            if (
              _.find(this.filteredSubgroups, filteredSubgroups => {
                return filteredSubgroups === subGroupInput;
              })
            ) {
              this.material
                .get('materialSelection')
                .get('subgroup')
                .patchValue(subGroupInput, { emitEvent: true });
            }
          }

          if (materialInput !== '') {
            if (
              _.find(this.materialList, materials => {
                return materials.uiName === materialInput;
              })
            ) {
              this.material
                .get('materialSelection')
                .get('material')
                .patchValue(materialInput, { emitEvent: true });
            }
          }

          if (conditionInput !== '') {
            if (
              _.find(this.conditionList, conditions => {
                return conditions.condition === conditionInput;
              })
            ) {
              this.material
                .get('materialSelection')
                .get('condition')
                .patchValue(conditionInput, { emitEvent: true });
              this.chosenCondition = true;
            }
          }

          if (subGroupInput !== '' && materialInput !== '' && conditionInput !== '') {
            this.loadHardness(this.materials['all']);
          }
        }
      }
    }
  };

  setArrowDirectionUp = (id, visible?) => {
    this.popupVisible[id] = true;
    if (id === 'subgroup') {
      this.materialOptionsPop.nativeElement.className = 'up arrow';
    } else if (id === 'material') {
      this.subgroupOptionsPop.nativeElement.className = 'up arrow';
    } else if (id === 'condition') {
      this.conditionOptionsPop.nativeElement.className = 'up arrow';
    }
  };

  setArrowDirectionDown = (id, visible?) => {
    this.popupVisible[id] = false;
    if (id === 'subgroup') {
      this.materialOptionsPop.nativeElement.className = 'down arrow';
    } else if (id === 'material') {
      this.subgroupOptionsPop.nativeElement.className = 'down arrow';
    } else if (id === 'condition') {
      this.conditionOptionsPop.nativeElement.className = 'down arrow';
    }
  };

  setMaterial = (control: string, value: string) => {
    if (value) {
      //Added back in the clear element and set arrow when user selects something from materials
      //To get the user selection before blur clears out the drop down we have to use mousedown or touchstart
      //Android devices captures both events and causing a double click and setting the wrong material so keep this here for now
      if (control === 'subgroup') {
        $('#material').blur();
        this.material
          .get('materialSelection')
          .get('subgroup')
          .patchValue(value, { emitEvent: false }); // adds the "material" into the input

        let list = [];
        const materialIds = this.settingsHolder.tool ? this.settingsHolder.tool.materialIds : null;
        for (let i = 0; i < this.materials['all'].length; i++) {
          if (
            this.materials['all'][i]['subGroup'] === value &&
            (!materialIds || !!materialIds.find(id => id === this.materials['all'][i].id))
          ) {
            list.push(this.materials['all'][i]);
          }
        }
        this.materialSubgroupList = _.uniqBy(list, 'uiName'); //got the subgroup list
        this.materialList = this.materialSubgroupList;

        if (this.currentSubgroup != value) {
          //there is a change
          this.currentSubgroup = value;
          this.material
            .get('materialSelection')
            .get('material')
            .reset('', { emitEvent: false });
          this.material
            .get('materialSelection')
            .get('condition')
            .reset('', { emitEvent: false });
          this.material.get('hardness').reset('', { emitEvent: false });
        }

        if (this.material.get('materialSelection').get('material').value !== '') {
          if (this.conditionList.length === 1) {
            this.material
              .get('materialSelection')
              .get('condition')
              .patchValue(this.conditionList[0]['condition'], { emitEvent: true });
            this.chosenCondition = true;
          } else {
            this.chosenCondition = false;
          }

          this.material
            .get('materialSelection')
            .get('condition')
            .enable();
        }

        this.subGroup = this.filteredSubgroups;
        if (this.isApp) {
          this.utils.apptentiveEngage('Sub Group');
        }
      }
      // this is fine, ultimately it only gets fired once
      else if (control === 'material') {
        $('#subgroup').blur();
        if (this.material.get('materialSelection').get('subgroup').value !== value['subGroup']) {
          //this means, the user when straigt for the Subgroup "material" field

          //set the "material" field
          this.material
            .get('materialSelection')
            .get('subgroup')
            .patchValue(value['subGroup'], { emitEvent: false });
          // generates the list of "subgroup"
          let list = [];
          const materialIdList = this.settingsHolder.tool ? this.settingsHolder.tool.materialIds : null;
          for (let i = 0; i < this.materials['all'].length; i++) {
            if (
              this.materials['all'][i]['subGroup'] === value['subGroup'] &&
              (!materialIdList || !!materialIdList.find(id => id === this.materials['all'][i].id))
            ) {
              list.push(this.materials['all'][i]);
            }
          }
          this.materialSubgroupList = _.uniqBy(list, 'uiName'); //got the subgroup list
          this.materialList = this.materialSubgroupList;
        }

        this.material
          .get('materialSelection')
          .get('material')
          .patchValue(value['uiName'], { emitEvent: false });
        this.materialList = this.materialSubgroupList;
        if (this.material.get('materialSelection').get('subgroup').value !== '') {
          let list = [];
          const materialIdList = this.settingsHolder.tool ? this.settingsHolder.tool.materialIds : null;
          for (let i = 0; i < this.materials['all'].length; i++) {
            if (
              this.materials['all'][i]['uiName'] === value['uiName'] &&
              (!materialIdList || !!materialIdList.find(id => id === this.materials['all'][i].id))
            ) {
              list.push(this.materials['all'][i]);
            }
          }

          this.conditionList = list;

          if (this.conditionList.length === 1) {
            this.material
              .get('materialSelection')
              .get('condition')
              .patchValue(this.conditionList[0]['condition'], { emitEvent: true });
            this.chosenCondition = true;
          } else {
            this.material
              .get('materialSelection')
              .get('condition')
              .reset('', { emitEvent: false });
            this.chosenCondition = false;
          }

          this.material
            .get('materialSelection')
            .get('condition')
            .enable();
        }
        if (this.isApp) {
          this.utils.apptentiveEngage('Material');
        }
      } else if (control === 'condition') {
        $('#condition').blur();
        this.chosenCondition = true;
        this.material
          .get('materialSelection')
          .get('condition')
          .patchValue(value, { emitEvent: true });
        if (this.isApp) {
          this.utils.apptentiveEngage('Condition');
        }
      }

      this.loadHardness(this.materials['all']);
      setTimeout(() => {
        this.commonService.notifyOther({
          option: 'recommendationsGeneratedForLoggingData',
          value: {
            logLocation: 'material change'
          }
        });
      });
    }
  };

  hardnessOverride = (type: HardnessFactor, value: number) => {
    this.currentHardness = this.convertHardness(type, value, true);
    this.material.get('hardness').patchValue(this.currentHardness, { emitEvent: false }); // emit false so it won't be part of the fields to watch

    const hardnessExt = this.currentHardness;
    this.hardnessChange.emit(hardnessExt);
  };

  convertHardness = (type: HardnessFactor, value: number, isUserInput: boolean = false): Hardness => {
    const hardness: Hardness = {};

    switch (type) {
      case HardnessFactor.HBW:
        hardness.hbw = value;
        hardness.hrc = Math.round(this.conversionFormulas.convertHBWtoHRC(value));
        hardness.hrb = Math.round(this.conversionFormulas.convertHBWtoHRB(value));
        hardness.hbs = Math.round(this.conversionFormulas.convertHRBtoHBS(hardness.hrb));

        if (isUserInput) {
          hardness.userHra = this.conversionFormulas.convertHBWtoHRA(hardness.hbw);
        }
        break;
      case HardnessFactor.HBS:
        hardness.hbs = value;
        hardness.hbw = Math.round(
          this.conversionFormulas.convertHRBtoHBW(this.conversionFormulas.convertHBStoHRB(value))
        );
        hardness.hrb = Math.round(this.conversionFormulas.convertHBStoHRB(hardness.hbs));
        hardness.hrc = Math.round(this.conversionFormulas.convertHBWtoHRC(hardness.hbw));

        if (isUserInput) {
          hardness.userHra = this.conversionFormulas.convertHBStoHRA(hardness.hbs);
        }
        break;
      case HardnessFactor.HRB:
        hardness.hrb = value;
        hardness.hbw = Math.round(this.conversionFormulas.convertHRBtoHBW(value));
        hardness.hrc = Math.round(this.conversionFormulas.convertHBWtoHRC(hardness.hbw));
        hardness.hbs = Math.round(this.conversionFormulas.convertHRBtoHBS(hardness.hrb));

        if (isUserInput) {
          hardness.userHra = this.conversionFormulas.convertHRBtoHRA(hardness.hrb);
        }
        break;
      case HardnessFactor.HRC:
        hardness.hrc = value;
        hardness.hbw = Math.round(this.conversionFormulas.convertHRCtoHBW(value));
        hardness.hrb = Math.round(this.conversionFormulas.convertHBWtoHRB(hardness.hbw));
        hardness.hbs = Math.round(this.conversionFormulas.convertHRBtoHBS(hardness.hrb));

        if (isUserInput) {
          hardness.userHra = this.conversionFormulas.convertHRCtoHRA(hardness.hrc);
        }
        break;
    }

    return hardness;
  };

  onEnter = control => {
    if (this.material.get('materialSelection').get(control).value !== '') {
      this.popupVisible[control] = false;
    } else {
      this.popupVisible[control] = true;
    }
  };

  onLeave = control => {
    this.popupVisible[control] = false;
  };

  onKeyUp = control => {
    if (this.material.get('materialSelection').get(control).value !== '') {
      this.popupVisible[control] = false;
    } else {
      this.popupVisible[control] = true;
    }
  };

  resetMaterial = () => {
    this.chosenCondition = false;
    this.material.get('materialSelection').reset(
      {
        material: '',
        subgroup: '',
        condition: '',
        subgroupSearch: '',
        materialSearch: '',
        conditionSearch: ''
      },
      { emitEvent: false }
    );

    // there is a bug in material 2 library when using inputs, the place holders does not get reset
    // using a jquery hack here to get it reset
    let materialLabel = $(this.materialInput.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!materialLabel.hasClass('mat-empty') && !materialLabel.hasClass('mat-form-field-empty')) {
      materialLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let subGroupLabel = $(this.subgroupInput.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!subGroupLabel.hasClass('mat-empty') && !subGroupLabel.hasClass('mat-form-field-empty')) {
      subGroupLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let conditionLabel = $(this.conditionInput.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!conditionLabel.hasClass('mat-empty') && !conditionLabel.hasClass('mat-form-field-empty')) {
      conditionLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let hbwLabel = $(this.hbw.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!hbwLabel.hasClass('mat-empty') && !hbwLabel.hasClass('mat-form-field-empty')) {
      hbwLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let hbsLabel = $(this.hbs.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!hbsLabel.hasClass('mat-empty') && !hbsLabel.hasClass('mat-form-field-empty')) {
      hbsLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let hrbLabel = $(this.hrb.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!hrbLabel.hasClass('mat-empty') && !hrbLabel.hasClass('mat-form-field-empty')) {
      hrbLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    let hrcLabel = $(this.hrc.nativeElement)
      .parents('.mat-form-field-infix')
      .find('.mat-form-field-label-wrapper')
      .find('.mat-form-field-label');
    if (!hrcLabel.hasClass('mat-empty') && !hrcLabel.hasClass('mat-form-field-empty')) {
      hrcLabel.addClass('mat-empty').addClass('mat-form-field-empty');
    }

    this.material.get('hardness').reset(
      {
        hbw: '',
        hrc: '',
        hbs: '',
        hrb: '',
        userHra: ''
      },
      { emitEvent: true }
    );

    this.resetHardnessActive = false;
  };

  resetHardness = () => {
    if (this.resetHardnessActive) {
      this.material.get('hardness').reset(
        {
          hbw: '',
          hrc: '',
          hbs: '',
          hrb: '',
          userHra: ''
        },
        { emitEvent: true }
      );
      this.loadHardness(this.materials['all']);
      this.material.get('hardness').patchValue(this.currentHardness, { emitEvent: false });
      this.resetHardnessActive = false;
    }
  };

  loadHardness = (data: Material_[]) => {
    // if all three is chosen then show the hardness data
    // we want to trigger the look up silently, so thats why I am checking if blank value you here with out the UI showing an error when blank
    if (this.utils.inputChecker(this.material.get('materialSelection').get('material').value, ['required'])) {
      let nameDescription = this.material
        .get('materialSelection')
        .get('material')
        .value.split('—');
      let name = nameDescription[0];
      let description = nameDescription[1];
      let uiName = this.material.get('materialSelection').get('material').value;
      let subgroup = this.material.get('materialSelection').get('subgroup').value;
      let condition = this.material.get('materialSelection').get('condition').value;

      let moreFilter = {
        name: _.trim(name),
        description: _.trim(description)
      };

      if (subgroup) {
        _.extend(moreFilter, {
          subgroup: subgroup
        });
      }

      if (condition) {
        _.extend(moreFilter, {
          condition: condition
        });
      }

      let result: Material_ = undefined;

      for (let i = 0; i < data.length; i++) {
        if (data[i]['condition'] === condition && data[i]['subGroup'] === subgroup && data[i]['uiName'] === uiName) {
          result = data[i];
          break;
        }
      }
      this.currentHardness = {
        hbs: '',
        hbw: '',
        hrc: '',
        hrb: '',
        userHra: ''
      };

      if (result) {
        this.currentHardness = this.convertHardness(HardnessFactor[result['hardnessFactor']], result['hardness']);

        // can't use setValue here because setValue is for init
        this.material.get('hardness').patchValue(this.currentHardness, { emitEvent: false }); // emit false so it won't be part of the fields to watch

        let hardnessExt = this.currentHardness;

        _.extend(result, hardnessExt);

        result = this.formulas.configureMaterial(result);

        _.extend(hardnessExt, {
          hra: result['hra']
        });

        this.hardnessChange.emit(hardnessExt);
      }
      _.extend(result, {
        chosenCondition: this.chosenCondition
      });
      this.materialChange.emit(result);
    }
  };
}
